package nl.volleyplanner.api.entities

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.types.PublicDataPayload
import nl.volleyplanner.api.types.TransformableToPublic
import nl.volleyplanner.types.AgeGroup

enum class PersonStatus {
    Active,
    Deleted
}

@Serializable
data class PersonId(
    val id: String
)

interface Person {
    val id: String
    val name: String
    val groups: Map<String, List<Group>>?
    val personStatus: PersonStatus
}

@Serializable
data class FullPerson(
    override val id: String,
    val relationNumber: String,
    override val name: String,
    val ageGroup: AgeGroup,
    override val personStatus: PersonStatus,
    override val groups: Map<String, List<Group>>?,
    val volunteerJobs: List<VolunteerJob>?,
    val anonymizedName: String
) : Person, TransformableToPublic<PublicPerson> {
    override fun toPublic(): PublicPerson {
        return PublicPerson(
            id = id,
            name = anonymizedName,
            groups = groups,
            personStatus = personStatus
        )
    }
}

@Serializable
data class PublicPerson(
    override val id: String,
    override val name: String,
    override val groups: Map<String, List<Group>>?,
    override val personStatus: PersonStatus
) : Person, PublicDataPayload

@Serializable
data class FindPersonRequest(
    val email: String
)

@Serializable
/**
 * Request payload for updating a person's core data and group memberships.
 * - teamGroupIds: list of team group IDs the person should belong to (complete replacement of teams)
 * - refereeGroupIds: list of referee group IDs (currently UI supports 0 or 1, but we keep it as list)
 */
data class PersonUpdateRequest(
    val id: String,
    val relationNumber: String,
    val name: String,
    val seasonName: String,
    val teamGroupIds: List<String>,
    val refereeGroupId: String?
)